"use client";

import { Badge } from "@/shared/ui/data-display/badge";
import { useTranslations } from "next-intl";
import type { MatchDisputeStatus, MatchDisputeResolutionType } from "@/entities/match-dispute";

interface DisputeStatusBadgeProps {
  status: MatchDisputeStatus;
  resolutionType?: MatchDisputeResolutionType | null;
}

export function DisputeStatusBadge({ status, resolutionType }: DisputeStatusBadgeProps) {
  const tUi = useTranslations("Ui");
  if (status === "Resolved" && resolutionType) {
    const labels: Record<MatchDisputeResolutionType, string> = {
      Uphold: tUi("litDisputeStatusBadge.rezultatOstavlen"),
      Overturn: tUi("litDisputeStatusBadge.rezultatOtmenen"),
      Reject: tUi("litDisputeStatusBadge.disputOtklonen"),
    };
    return (
      <Badge variant="outline" className="capitalize">
        {labels[resolutionType]}
      </Badge>
    );
  }
  const statusLabels: Record<MatchDisputeStatus, string> = {
    Open: tUi("litDisputeStatusBadge.otkryt"),
    InReview: tUi("litDisputeStatusBadge.naRassmotrenii"),
    Resolved: tUi("litDisputeStatusBadge.rassmotren"),
    Rejected: tUi("litDisputeStatusBadge.otklonen"),
  };
  const variant =
    status === "Open" ? "secondary" : status === "InReview" ? "default" : "outline";
  return <Badge variant={variant}>{statusLabels[status]}</Badge>;
}
